const handlerOnFieldValidation = async (onFieldValidation, name, hasError) => {
  if (onFieldValidation) await onFieldValidation({ name, hasError })
}

const getInputName = name => name || `input-${Math.floor(Math.random() * 2000)}`

export { handlerOnFieldValidation, getInputName }
